import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClapboardWide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clapboard-wide, movie, film"><path d="M22 18.25C22 19.2165 21.2165 20 20.25 20H3.75C2.7835 20 2 19.2165 2 18.25V10.5H22V18.25Z" fill="currentColor"/><path d="M6.75098 9H2V5.75C2 4.7835 2.7835 4 3.75 4H8.41797L6.75098 9Z" fill="currentColor"/><path d="M14 9H8.33301L10 4H15.667L14 9Z" fill="currentColor"/><path d="M22 9H15.582L17.249 4H20.25C21.2165 4 22 4.7835 22 5.75V9Z" fill="currentColor"/></CentralIconBase>;
};

export default IconClapboardWide;
